import React from "react";
import { FaLinkedin, FaTwitter } from "react-icons/fa";
import { GoMarkGithub } from "react-icons/go";
import { BiFile } from "react-icons/bi";

export const links = [
  {
    id: 1,
    url: "/",
    text: "home",
  },
  {
    id: 2,
    url: "/projects",
    text: "projects",
  },
  {
    id: 3,
    url: "/about",
    text: "about",
  },
  {
    id: 4,
    url: "/contact",
    text: "contact",
  },
];

export const social = [
  {
    id: 1,
    url: "/",
    icon: "",
  },

  {
    id: 3,
    url: "https://github.com/Bbeyenene",
    icon: <GoMarkGithub />,
  },
  {
    id: 4,
    url: "https://www.linkedin.com",
    icon: <FaLinkedin />,
  },
  {
    id: 5,
    url: "https://www.twitter.com",
    icon: <FaTwitter />,
  },
];
